import Logo from '../../assets/logo/aveda-logo.svg';
import { Global } from '@emotion/react';
import { globalLogin, LoginContainer, LoginLogo, LoginTitle } from './Login.styles';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import axios, { AxiosError } from 'axios';
import { useNotification } from '../../components';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
 
const Login = () => {
  const { t } = useTranslation();
  const { showMessage } = useNotification();
 
  const [isAuthenticated, setIsAuthenticated] = useState(false);
 
  useEffect(() => {
    const authState = !!Cookies.get('user_id');
    setIsAuthenticated(authState);
  }, [isAuthenticated]);
 
  const logout = async () => {
    try {
      await axios.post(
        `${import.meta.env.VITE_APP_BACKEND_URL}/user/logout`,
        {},
        {
          params: {
            token: Cookies.get('logout_token'),
            _format: 'json',
          },
          headers: { ['X-CSRF-Token']: Cookies.get('csrf_token') },
          withCredentials: true,
        },
      );
      Cookies.remove('csrf_token');
      Cookies.remove('logout_token');
      Cookies.remove('user_id');
      setIsAuthenticated(false);
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError.response?.status === 403) {
        const errorMessage =
          ('Your session has expired due to inactivity. Please close the application, clear your browser cookies, and log in again to resolve 403 error.');
        showMessage(errorMessage, 'error');
        return;
      }
      showMessage('Logout option is unavailable now, try again later.', 'error');
    }
  };
 
  const login = async () => {
    try {
      const { data } = await axios(`${import.meta.env.VITE_APP_BACKEND_URL}/api/v1/authenticate`, {
        params: {
          _format: 'json',
        },
      });
      window.location = data;
    } catch {
      showMessage('Authorization servise is unavailable now, try again later.', 'error');
    }
  };
 
  return (
    <>
      <Global styles={globalLogin} />
      <LoginContainer maxWidth="sm">
        <LoginLogo src={Logo} alt="Aveda" />
        <LoginTitle variant="h4">{t('login.appTitle')}</LoginTitle>
        <Button fullWidth variant="contained" onClick={isAuthenticated ? logout : login}>
          {t(isAuthenticated ? 'login.logoutBtn' : 'login.loginBtn')}
        </Button>
      </LoginContainer>
    </>
  );
};
 
export default Login;
 